module.exports = __webpack_public_path__ + "static/media/autokar2 (6).63b7a89f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (6).jpg
// module id = 853
// module chunks = 0